/**
 * Estilos compartilhados do Simulador Demo Comercial (Fase 8B).
 * Paleta baseada no WhatsApp Web dark + acentos AgentUS (âmbar).
 */
export const DEMO_COLORS = {
  bg: "#0b141a",
  panel: "#202c33",
  panelAlt: "#2a3942",
  border: "#0b141a",
  divider: "#3b4a54",
  text: "#e9edef",
  textDim: "#8696a0",
  bubbleIn: "#005c4b",  // verde WhatsApp — cliente simulado
  bubbleOut: "#202c33", // grafite — IA
  accent: "#f59e0b",    // âmbar AgentUS
  accentSoft: "#fbbf24",
  danger: "#ef4444",
  success: "#00a884",
};

export const DIFFICULTY_STYLES = {
  easy: { bg: "rgba(16, 185, 129, 0.15)", color: "#10b981", label: "Fácil" },
  medium: { bg: "rgba(245, 158, 11, 0.15)", color: "#f59e0b", label: "Médio" },
  hard: { bg: "rgba(239, 68, 68, 0.15)", color: "#ef4444", label: "Difícil" },
};

export function fmtBRL(value) {
  const n = Number(value) || 0;
  return n.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
    maximumFractionDigits: 0,
  });
}

export function fmtInt(value) {
  const n = Number(value) || 0;
  return n.toLocaleString("pt-BR");
}
